<li ngbDropdown class="nav-item filtro-lojas mr-50" autoClose="outside" placement="bottom-right" (openChange)="aoAbrir($event)">
  <!-- Gatilho: pílula com o resumo da seleção -->
  <a
    class="nav-link filtro-gatilho"
    ngbDropdownToggle
    href="javascript:void(0)"
    [attr.aria-label]="'Filtro global de lojas e grupos: ' + rotuloGatilho"
  >
    <span class="feather icon-sliders filtro-gatilho-icone"></span>
    <span class="filtro-gatilho-texto d-none d-lg-inline-flex">
      <span class="filtro-eyebrow">Filtro</span>
      <span class="filtro-rotulo">{{ rotuloGatilho }}</span>
    </span>
    <span *ngIf="selecionados.size > 0" class="filtro-contador">{{ selecionados.size }}</span>
    <span class="feather icon-chevron-down filtro-chevron"></span>
  </a>

  <div ngbDropdownMenu class="dropdown-menu-right filtro-painel">
    <!-- Cabeçalho -->
    <div class="filtro-cabecalho">
      <div class="d-flex align-items-start justify-content-between">
        <div>
          <span class="filtro-pill">
            <span class="feather icon-sliders"></span>
            Filtro global
          </span>
          <h6 class="filtro-titulo">Loja / Grupo econômico</h6>
        </div>
        <div class="d-flex align-items-center filtro-atalhos">
          <button type="button" class="filtro-atalho filtro-atalho-primario" (click)="selecionarTodos()" [disabled]="totalLojas === 0">
            <span class="feather icon-check"></span> Todos
          </button>
          <button type="button" class="filtro-atalho" (click)="limpar()" [disabled]="selecionados.size === 0">
            <span class="feather icon-x"></span> Limpar
          </button>
        </div>
      </div>

      <p class="filtro-descricao">
        Selecione as lojas ou grupos que vão filtrar os dados de toda a aplicação.
      </p>

      <div class="filtro-busca">
        <span class="feather icon-search"></span>
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por loja, grupo, cidade ou CNPJ..."
          aria-label="Buscar lojas, grupos ou CNPJ"
          [ngModel]="termoBusca"
          (ngModelChange)="aoBuscar($event)"
        />
        <button *ngIf="termoBusca" type="button" class="filtro-busca-limpar" (click)="aoBuscar('')" aria-label="Limpar busca">
          <span class="feather icon-x"></span>
        </button>
      </div>

      <span *ngIf="selecionados.size > 0" class="filtro-resumo">
        <span class="feather icon-check"></span>
        {{ selecionados.size }} de {{ totalLojas }} {{ totalLojas === 1 ? 'selecionada' : 'selecionadas' }}
      </span>
    </div>

    <!-- Lista -->
    <div class="filtro-lista">
      <!-- Carregando -->
      <ng-container *ngIf="carregando">
        <div class="filtro-skeleton" *ngFor="let i of [0, 1, 2]">
          <span class="sk sk-circulo"></span>
          <span class="sk sk-quadrado"></span>
          <span class="sk-linhas">
            <span class="sk sk-linha"></span>
            <span class="sk sk-linha curta"></span>
          </span>
        </div>
      </ng-container>

      <!-- Erro -->
      <div *ngIf="!carregando && erro" class="filtro-estado">
        <span class="filtro-estado-icone"><span class="feather icon-alert-triangle text-warning"></span></span>
        <p class="filtro-estado-titulo">Não foi possível carregar suas lojas</p>
        <p class="filtro-estado-texto">Verifique sua conexão e tente novamente.</p>
        <button type="button" class="btn btn-outline-primary btn-sm round" (click)="carregar()">Tentar novamente</button>
      </div>

      <!-- Sem lojas -->
      <div *ngIf="!carregando && !erro && grupos.length === 0" class="filtro-estado">
        <span class="filtro-estado-icone"><span class="feather icon-layers"></span></span>
        <p class="filtro-estado-titulo">Nenhuma loja disponível</p>
        <p class="filtro-estado-texto">Seu usuário ainda não tem lojas ou grupos vinculados.</p>
      </div>

      <!-- Busca sem resultado -->
      <div *ngIf="!carregando && grupos.length > 0 && lista.length === 0" class="filtro-estado">
        <span class="filtro-estado-icone"><span class="feather icon-search"></span></span>
        <p class="filtro-estado-titulo">Nada encontrado</p>
        <p class="filtro-estado-texto">Nenhum resultado para "{{ termoBusca }}". Tente outro termo.</p>
      </div>

      <ng-container *ngIf="!carregando">
        <ng-container *ngFor="let item of lista; let i = index; trackBy: trackGrupo">
          <!-- Rótulos de seção -->
          <div *ngIf="i === 0 && qtdGruposSelecionados > 0" class="filtro-secao destaque">
            <span>Selecionadas</span>
            <span class="filtro-secao-contador">{{ qtdGruposSelecionados }}</span>
            <span class="filtro-secao-linha"></span>
          </div>
          <div *ngIf="i === qtdGruposSelecionados && qtdGruposSelecionados > 0" class="filtro-secao">
            <span>Todas as lojas</span>
            <span class="filtro-secao-linha"></span>
          </div>

          <!-- Loja sem grupo: card compacto -->
          <div
            *ngIf="item.grupo.avulsa; else cardGrupo"
            class="filtro-card"
            [class.ativo]="item.selecionado"
            role="button"
            tabindex="0"
            [attr.aria-pressed]="item.selecionado"
            (click)="toggleLoja(item.grupo.lojas[0])"
            (keydown.enter)="$event.preventDefault(); toggleLoja(item.grupo.lojas[0])"
            (keydown.space)="$event.preventDefault(); toggleLoja(item.grupo.lojas[0])"
          >
            <span class="filtro-check" [class.marcado]="item.selecionado">
              <span *ngIf="item.selecionado" class="feather icon-check"></span>
            </span>
            <span class="filtro-avatar"><span class="feather icon-shopping-bag"></span></span>
            <span class="filtro-card-texto">
              <span class="filtro-card-nome">{{ item.grupo.lojas[0].nome }}</span>
              <span class="filtro-card-sub">
                <ng-container *ngIf="item.grupo.lojas[0].local">{{ item.grupo.lojas[0].local }} · </ng-container>{{ item.grupo.lojas[0].cnpj | cpfCnpj }}
              </span>
            </span>
          </div>

          <!-- Grupo econômico -->
          <ng-template #cardGrupo>
            <div class="filtro-grupo">
              <div
                class="filtro-card"
                [class.ativo]="item.selecionado"
                [class.parcial]="item.parcial"
                role="button"
                tabindex="0"
                [attr.aria-pressed]="item.selecionado"
                (click)="toggleGrupo(item.grupo)"
                (keydown.enter)="$event.preventDefault(); toggleGrupo(item.grupo)"
                (keydown.space)="$event.preventDefault(); toggleGrupo(item.grupo)"
              >
                <span class="filtro-check" [class.marcado]="item.selecionado" [class.parcial]="item.parcial">
                  <span *ngIf="item.selecionado" class="feather icon-check"></span>
                  <span *ngIf="item.parcial" class="filtro-check-ponto"></span>
                </span>
                <span class="filtro-avatar"><span class="feather icon-briefcase"></span></span>
                <span class="filtro-card-texto">
                  <span class="filtro-card-nome">{{ item.grupo.nome }}</span>
                </span>
                <span class="filtro-badge">
                  {{ item.grupo.lojas.length }} {{ item.grupo.lojas.length === 1 ? 'loja' : 'lojas' }}
                </span>
                <button
                  type="button"
                  class="filtro-expandir"
                  [attr.aria-expanded]="item.expandido"
                  [attr.aria-label]="(item.expandido ? 'Recolher lojas de ' : 'Expandir lojas de ') + item.grupo.nome"
                  (click)="toggleExpandir(item.grupo, $event)"
                  (keydown.enter)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()"
                >
                  <span class="feather icon-chevron-down" [class.girado]="item.expandido"></span>
                </button>
              </div>

              <!-- Lojas do grupo (recolhido por padrão) -->
              <div *ngIf="item.expandido" class="filtro-lojas-do-grupo">
                <div
                  *ngFor="let loja of item.lojasVisiveis; trackBy: trackLoja"
                  class="filtro-loja"
                  [class.ativo]="selecionados.has(loja.cnpj)"
                  role="button"
                  tabindex="0"
                  [attr.aria-pressed]="selecionados.has(loja.cnpj)"
                  (click)="toggleLoja(loja)"
                  (keydown.enter)="$event.preventDefault(); toggleLoja(loja)"
                  (keydown.space)="$event.preventDefault(); toggleLoja(loja)"
                >
                  <span class="filtro-check pequeno" [class.marcado]="selecionados.has(loja.cnpj)">
                    <span *ngIf="selecionados.has(loja.cnpj)" class="feather icon-check"></span>
                  </span>
                  <span class="filtro-card-texto">
                    <span class="filtro-loja-nome">{{ loja.nome }}</span>
                    <span class="filtro-card-sub">
                      <ng-container *ngIf="loja.local">{{ loja.local }} · </ng-container>{{ loja.cnpj | cpfCnpj }}
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-container>
      </ng-container>
    </div>
  </div>
</li>
